<template>
  <div class="evaluationWrap">
    <div class="card">
      <div class="cardTips">
        <div class="line"></div>
        <div class="txt">
          {{ isEvlatued ? '服务评价结果' : '您对医生助手的服务满意吗？' }}
        </div>
        <div class="line"></div>
      </div>
      <div class="cardConfig">
        <div class="cardItem" v-for="(item, index) in EvaluationConfig" :key="index">
          <auth-img class="iconImg" :src="calcSatusImg(item, index)" alt="" />
          <div class="iconlabel" v-if="!isEvlatued">{{ item.label }}</div>
        </div>
      </div>
      <div class="cardResult" v-if="isEvlatued && activeIndex > -1">
        评价结果：{{ EvaluationConfig[activeIndex].label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { EvaluationTypes } from './config'
import { defineProps, computed } from 'vue'

const props = defineProps({
  evaluteConfig: {
    type: Object,
    default: () => {}
  }
})

const EvaluationConfig = EvaluationTypes

const { msg, bodies } = props.evaluteConfig || {}
const { evaluateResult, customEvent } = msg || bodies

// 29401 未评价 29402 已评价
const isEvlatued = computed(() => customEvent !== '29401')

const EvalutedStatus = computed(() => Number(evaluateResult))

const activeIndex = EvaluationConfig.findIndex(item => item.status === EvalutedStatus.value)

const calcSatusImg = (ctxImg, ctxIndex) => {
  if (!isEvlatued.value) {
    return ctxImg.icon
  } else {
    return ctxIndex === activeIndex ? ctxImg.activeIcon : ctxImg.icon
  }
}
</script>
<style lang="scss" scoped>
.evaluationWrap {
  display: flex;
  justify-content: center;

  .card {
    width: 328px;
    text-align: center;

    .cardTips {
      display: flex;
      align-items: center;
      justify-content: center;

      .txt {
        margin: 0 20px;
        vertical-align: -8%;
        color: #999999;
      }

      .line {
        flex: 1;
        border-top: 1px solid #999999;
      }
    }

    .cardConfig {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 24px;

      .cardItem {
        text-align: center;

        .iconImg {
          width: 32px;
          height: 32px;
          margin-bottom: 10px;
        }

        .iconlabel {
          font-size: 14px;
          color: #1a1a1a;
        }
      }
    }
    .cardResult {
      font-weight: 400;
      font-size: 14px;
      color: #1a1a1a;
    }
  }
}
</style>
